import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IDataTableFilterChipsProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useDataTableSelectionBarContext,
    useDataTableContext
} from "../../context";
import Button from "../../../button";
import Chip from "../../../chip";
import Text from "../../../text";

const DataTableFilterChips: FC<IDataTableFilterChipsProps> = ({
    customTheme: customThemeProp,
    style,
    title,
    ...props
}) => {
    const context = useDataTableContext({
        part: "FilterChips"
    });

    const selectionBarContext = useDataTableSelectionBarContext();

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        isSelectionBarActive: selectionBarContext?.isSelectionBarActive ?? false,
        spaces
    });

    if(!context) {
        return null;
    }

    const currentTheme = customThemeProp ?? context.customTheme;

    const chips = context.allColumns.flatMap((column) => (context.columnFilters[column.id] ?? []).map((value) => ({
        label: column.filterOptions?.find((option) => option.value === value)?.label ?? value,
        header: column.header,
        columnId: column.id,
        value
    })));

    if(chips.length === 0 || context.layout === "cards") {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="group"
    >
        <Text
            customTheme={currentTheme}
            variant="labelSmallSize"
            color="low"
        >
            {title ?? localize("data-table-active-filters")}
        </Text>
        {
            chips.map((chip) => <Chip
                onClose={() => context.handleColumnFilterChange(chip.columnId, (context.columnFilters[chip.columnId] ?? []).filter((item) => item !== chip.value))}
                title={localize("data-table-filter-chip", [
                    chip.header,
                    chip.label
                ])}
                key={`${chip.columnId}-${chip.value}`}
                customTheme={currentTheme}
                isClosable={true}
                type="neutral"
                size="small"
            />)
        }
        <Button
            title={localize("data-table-clear-filters")}
            onPress={() => context.handleClearFilters()}
            customTheme={currentTheme}
            variant="ghost"
            type="neutral"
            size="small"
        />
    </View>;
};
export default DataTableFilterChips;
